import Lenis from '@studio-freight/lenis';

const isMobile = window.matchMedia('(max-width: 768px)').matches;
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

let lenis = null;
let scrollLockCount = 0;

export function lockPageScroll() {
    scrollLockCount += 1;
    if (scrollLockCount !== 1) return;

    lenis?.stop();
    document.documentElement.classList.add('scroll-locked');
    document.body.classList.add('scroll-locked');
}

export function unlockPageScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount !== 0) return;

    document.documentElement.classList.remove('scroll-locked');
    document.body.classList.remove('scroll-locked');
    lenis?.start();
}

if (!isMobile && !prefersReducedMotion) {
    lenis = new Lenis({
        duration: 0.8,
        easing: (t) => 1 - Math.pow(1 - t, 3),
        smoothWheel: true,
        smoothTouch: true,
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
}
